class User {
  id: number;

  name: string;

  email: string;

  companyName: string;

  recordingTips: boolean;

  stripeClientSecret: string;

  backupEmail: string;

  backupName: string;

  country?: string;

  state: string;

  verified: boolean;

  firstVaultPaymentProcessed: boolean;

  paymentMethods: PaymentMethodType[];

  subscriptionDeals: SubscriptionDealResponseType[];

  permissions?: UserPermissionsType;

  trialVaultId?: number;

  // Owns a pre-storage-plan vault: billed off the saved card and discount
  // code instead of through Stripe's Customer Portal.
  legacyBilling?: boolean;

  firstVisitDisplayed: boolean;

  onboardingStatus?: OnboardingStatus;

  constructor(params?: UserType) {
    this.id = params?.id || -1;
    this.name = params?.name || '';
    this.email = params?.email || '';
    this.companyName = params?.companyName || '';
    this.recordingTips = params?.recordingTips || false;
    this.stripeClientSecret = params?.stripeClientSecret || '';
    this.backupEmail = params?.backupEmail || '';
    this.backupName = params?.backupName || '';
    this.country = params?.country || undefined;
    this.state = params?.state || '';
    this.verified = params?.verified || false;
    this.firstVaultPaymentProcessed =
      params?.firstVaultPaymentProcessed || false;
    this.paymentMethods = params?.paymentMethods || [];
    this.subscriptionDeals = params?.subscriptionDeals || [];
    this.permissions = params?.permissions;
    this.trialVaultId = params?.trialVaultId || undefined;
    this.legacyBilling = params?.legacyBilling ?? false;
    this.firstVisitDisplayed = !!params?.firstVisitDisplayed;
    this.onboardingStatus = params?.onboardingStatus;
  }
}

export { User };
